import actionTypes from '../actionTypes';

export const FETCH_BOOKS = actionTypes('FETCH_BOOKS');
export const FETCH_BOOK_DETAILS = actionTypes('FETCH_BOOK_DETAILS');
export const UPDATE_BOOK_DETAILS = actionTypes('UPDATE_BOOK_DETAILS');
